import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import ReactTooltip from "react-tooltip";

import { HiMagnifyingGlass } from "react-icons/hi2";

import { campaignAction } from "../../store/campaign-store";

import TemplateList from "../Templates/TemplateList";
import { cuteToast } from "../UI/cute";
import Input from "../UI/Input";
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);
const Create = () => {
  const campaignRef = useRef();
  const [campaign, setCampaign] = useState({
    campaign_name: "",
    template_id: "",
    is_available: undefined,
    script_data: "",
    lead_details: "",
  });

  const [showFav, setShowFav] = useState(0);
  const [select_temp_type, setSelect_temp_type] = useState('FHD');

  const [search_temp, setSearch_temp] = useState('');

  const [isValid, setIsValid] = useState(undefined);
  const token = useSelector((state) => state.auth.token);

  const { sendRequest: checkCampaign } = useHttp();
  const { error, setError, sendRequest: insertCampaign } = useHttp();
  const dispatch = useDispatch();
  const history = useHistory();


  const scrollRef = useRef(null);


  useEffect(() => {
    ReactTooltip.rebuild();
  });

  useEffect(() => {
    document.title = `Create Campaign`;
  });
  // const responseData = (response) => {
  //   // console.log(response);

  //   if (response.status === 0) {
  //     setCampaign({ ...campaign, is_available: true });
  //     if (campaign.template_id !== "" && campaign.template_id) {
  //       setIsValid(true);
  //     } else {
  //       setIsValid(false);
  //     }
  //   } else {
  //     setCampaign({ ...campaign, is_available: false });
  //   }
  // };
  const campaignHandler = (event) => {
    const { value } = event.target;
    if (value) {
      // setCampaign({ ...campaign, campaign_name: value });

      checkCampaign(
        {
          url: endPoints.checkCampaignExits,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: {
            name: value,
          },
        },
        (response) => {
          // console.log(response);

          if (response.status === 0) {
            setCampaign({
              ...campaign,
              campaign_name: value,
              is_available: true,
            });
            if (campaign.template_id !== "" && campaign.template_id) {
              setIsValid(true);
            } else {
              setIsValid(false);
            }
          } else {
            setCampaign({
              ...campaign,
              campaign_name: value,
              is_available: false,
            });
          }
        }
      );
    } else {
      setCampaign({ ...campaign, campaign_name: "", is_available: undefined });
      setIsValid(false);
    }

    // console.log(campaign);
  };

  useEffect(() => {
    if (campaign.campaign_name === "") {
      // campaignRef.current.focus();
    }

    // console.log("Calling");
  });



  // const campaignHandlerBlur = () => {
  //   if (campaign.campaign_name) {
  //     checkCampaign(
  //       {
  //         url: endPoints.checkCampaignExits,
  //         method: "POST",
  //         headers: {
  //           "access-control-allow-origin": "*",
  //           "Content-Type": "application/json",
  //           Authorization: "Bearer " + token,
  //         },
  //         body: {
  //           name: campaign.campaign_name,
  //         },
  //       },
  //       responseData
  //     );
  //   }
  // };

  const templateHandler = (id, auto = false) => {
    // Ensure the template gets selected
    setCampaign({ ...campaign, template_id: id });

    // Proceed with retrieving script_data and setting campaign state
    var script_data = localStorage.getItem("script_data");
    var keyword = localStorage.getItem("keyword");
    var campid = localStorage.getItem("campid");
    var app = localStorage.getItem("app");

    if (keyword !== null) {
      keyword = keyword.replace(/['"]+/g, '');
    }
    if (campid !== null) {
      campid = campid.replace(/['"]+/g, '');
    }
    if (app !== null) {
      app = app.replace(/['"]+/g, '');
    }

    var lead_details = { keyword: keyword, campid: campid, app: app };

    // console.log('Lead details found!');
    // console.log(lead_details);

    if (script_data && lead_details) {
      script_data = JSON.parse(script_data);
      // console.log('Script data found!');
      // console.log(script_data);
      setCampaign({ ...campaign, template_id: id, script_data: script_data, lead_details: lead_details });
      // console.log('Campaign state set!');
      console.log(campaign);
    } else {
      console.log('No script data found!');
      setCampaign({ ...campaign, template_id: id });
    }

    // Only show error if not auto-selected and campaign name is missing
    if (!auto && campaign.campaign_name.trim() === "") {
      setIsValid(false);
      campaignRef.current.focus();

      cuteToast({
        type: "error",
        message: "Please enter a campaign name before selecting a template.",
        timer: 5000,
        title: "Missing Campaign Name",
      });

      // Use scrollIntoView for better scrolling behavior
      campaignRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });

      return;
    }


    if (campaign.campaign_name !== "") {
      setIsValid(true);
      scrollToRef(scrollRef);
    }
  };



  const resposeCamp = (response) => {
    // console.log(response);

    //remove local storage
    localStorage.removeItem("script_data");
    localStorage.removeItem("keyword");
    localStorage.removeItem("campid");
    localStorage.removeItem("app");


    dispatch(campaignAction.setEditorpageLoad({ editor_page_load: false }));

    if (response.id) {
      history.push("/campaign/" + response.id + "/edit");
    }
  };

  const handleSubmit = () => {
    // console.log(campaign)
    // return false;
    if (isValid && campaign.is_available) {
      insertCampaign(
        {
          url: endPoints.insertCampaign,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: {
            ...campaign,
          },
        },
        resposeCamp
      );
    } else {
      cuteToast({
        type: "error",
        message: "Pease enter campaign name and select tempplate",
        timer: 5000,
        title: "Campaign Invalid",
      });
      campaignRef.current.focus();
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (error) {
      // console.log(error);

      cuteToast({
        type: "error",
        message: error,
        timer: 5000,
        title: "Campaign Invalid",
      });

      setCampaign({ ...campaign, is_available: false });
      campaignRef.current.focus();
      setError(null);
    } else {
      console.log("Hello error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const handleFav = (event) => {
    setShowFav(parseInt(event.target.value));
  };



  return (
    <>
      <section className="mid_wrap">
        <ReactTooltip />
        <div className="container">
          <div className="row align-items-center mb-4">
            <div className="col-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Create video</li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row mb-4 ">
            <div className="col-xl-5 col-lg-6 col-md-8">
              {campaign.campaign_name.trim().length > 0 && (
                <label className="pull-right">
                  <span className="pull-right">
                    {campaign.campaign_name.length}/20
                  </span>
                </label>
              )}
              <Input
                ref={campaignRef}
                name="campaign_name"
                type="text"
                placeholder="Enter Campaign Name"
                maxLength={20}
                inputClass={`form-control txt1 light-placeholder ${campaign.campaign_name.length >= 20 && "max-length"
                  } ${!campaign.is_available &&
                  campaign.is_available !== undefined &&
                  "invalid"
                  }`}
                onChange={campaignHandler}

              // onBlur={campaignHandlerBlur}
              />
              {campaign.campaign_name.trim().length > 0 && campaign.is_available === true && (
                <p className="available text-success pull-right">
                  <b>Available</b>
                </p>
              )}

              {campaign.campaign_name.trim().length > 0 && campaign.is_available === false && (
                <p className="red_lnk text-danger font-weight-bold pull-right">
                  <b>Not Available</b>
                </p>
              )}
            </div>
            <div className="col-xl-7 col-lg-6 col-md-4">

              <div className="btn-group btn-group-toggle select_temp pull-right d-none" data-toggle="buttons">

                <label className={` btn  ${(select_temp_type === 'All') ? "btnactive" : " "}`} onClick={() => { setSelect_temp_type('All') }} > All </label>
                <label data-tip="Full HD Videos 1920 x 1080" className={` btn  ${(select_temp_type === 'FHD') ? "btnactive" : " "}`} onClick={() => { setSelect_temp_type('FHD') }}>  FHD  </label>
                <label data-tip="Box Videos 1080 x 1080" className={` ml1 btn  ${(select_temp_type === 'Box') ? "btnactive" : " "}`} onClick={() => { setSelect_temp_type('Box') }}>  Box  </label>
                <label data-tip="Wide Videos 2880 x 720" className={` btn  ${(select_temp_type === 'Wide') ? "btnactive" : " "}`} onClick={() => { setSelect_temp_type('Wide') }}>  Wide  </label>
                <label data-tip="Vertical Videos 1080 x 1920" className={` btn  ${(select_temp_type === 'Vertical') ? "btnactive" : " "}`} onClick={() => { setSelect_temp_type('Vertical') }}  > Vertical</label>

              </div>

              <div className="btn-group btn-group-toggle select_temp2 pull-right " data-toggle="buttons">

                <label className={` btn  ${(showFav === 0) ? "btnactive" : " "}`}
                  onClick={() => { setShowFav(0); }} > All </label>
                <label className={` btn  ${(showFav === 1) ? "btnactive" : " "}`}
                  onClick={() => { setShowFav(1); }}>  My Favourite  </label>

              </div>



              {isValid && (
                <>
                  <button
                    style={{ marginTop: "5%" }}
                    className="btn min_w  "
                    onClick={handleSubmit}
                  >
                    Save & Next
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-12 d-flex justify-content-between">
              <h2 className="m-0">Select A Template</h2>
              <div className="search_box">

                <div className="d-flex">
                  <input type="text" className="form-control text-center select_temp_type"
                    value={search_temp}
                    onChange={(e) => {
                      setSearch_temp(e.target.value)
                      //focus this input
                      document.querySelector('.select_temp_type').focus();
                    }
                    }
                    placeholder="Search Template"
                  />
                  <HiMagnifyingGlass className="magnify" />
                </div>
                <button className="btn showallbtn" onClick={(e) => { setSearch_temp(e.target.value) }} >Show All</button>
              </div>
            </div>

            <div className="col-4 d-flex d-none">
              <select
                name=""
                className="form-control slectbx wdh_auto text-center ms-auto"
                onChange={handleFav}
                value={showFav}
              >
                <option value="0">All</option>
                <option value="1">My Favourite</option>
              </select>
            </div>
          </div>

          <div className="row">
            <TemplateList
              templateId={templateHandler}
              selectedTemp={campaign.template_id}
              showFav={showFav}
              select_temp_type={select_temp_type}
              search_temp={search_temp}
              setSearch_temp={setSearch_temp}
            />
          </div>

          <div className="rw text-end" ref={scrollRef}>
            {isValid && (
              <button className="btn min_w" onClick={handleSubmit}>
                Save & Next
              </button>
            )}
          </div>
        </div>

      </section>
    </>
  );
};

export default Create;
